import { RootState } from './shared.reducer';

const defaultVal = {
  socialLinks: {
    "facebook": "",
    "twitter": "",
    "youtube": "",
    "linkedin": ""
  },
  isLoading: false,
};
export const socialsConfigState = (state: any | RootState) => {
  return state.homepage
    ? state.homepage.social
      ? state.homepage.social
      : defaultVal
    : defaultVal;
};
